import Sidebar from  '../Components/Sidebar/index';
import Navbar from '../Components/Navbar/index';
import { useState } from 'react';
import HeroSection from '../Components/HeroSection';
import InfoSection from '../Components/InfoSection';
import { homeObjOne } from '../Components/InfoSection/Data' 
import Services from '../Components/Services/index';
import Footer from '../Components/Footer';
import TechStackInfo from '../Components/TechStackInfo';
import Contact from "../Components/Contact/index"

const Home = () => {
    const [ isOpen, setIsOpen ] = useState(false);
    
    const  toggle = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
        <Sidebar  isOpen = {isOpen} toggle = {toggle}/>
        <Navbar toggle = {toggle}/>
        <HeroSection />
        <InfoSection { ...homeObjOne }/>
        {/* <StackContainer>
            <StackImage src = {techStack} alt = "MERN Stack"/>
        </StackContainer> */}
        <TechStackInfo />
        <Services />
        <Contact />
        <Footer />
        </>
    )
}
export default Home;